import React, { useState } from 'react';
import { MdSearch, MdMenu } from 'react-icons/md';
import styles from './Topbar.module.css';

const Topbar = ({ toggleSidebar, isSidebarOpen }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [user, setUser] = useState(null);

    React.useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        }
    }, []);

    const userRoleName = user?.role?.roleName;
    const isCROAdmin = userRoleName === 'CRO Admin';
    const isPIUser = userRoleName === 'Principal Investigator' || userRoleName === 'Co-ordinator member';
    const isSponsor = userRoleName === "Sponsor";


    return (
        <div className={`${styles.topbar} ${isSidebarOpen ? styles.expanded : styles.collapsed}`}>
            <div className={styles.leftSection}>
                <button className={styles.mobileMenuBtn} onClick={toggleSidebar}>
                    <MdMenu />
                </button>
                <h1 className={styles.title}>
                    {isCROAdmin && 'CRO Portal'}
                    {isSponsor && "SP Portal"}
                    {isPIUser && "PI Portal"}
                </h1>
            </div>

            <div className={styles.rightSection}>
                <div className={styles.searchBar}>
                    <MdSearch className={styles.searchIcon} />
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className={styles.searchInput}
                    />
                </div>
            </div>
        </div>
    );
};

export default Topbar;